import { useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import { BACKEND_URL } from '../lib/backend';

const API = `${BACKEND_URL}/api`;

export function useSSE(onEvent) {
  const { isAuthenticated } = useAuth();
  const eventSourceRef = useRef(null);
  const onEventRef = useRef(onEvent);

  useEffect(() => { onEventRef.current = onEvent; }, [onEvent]);

  useEffect(() => {
    if (!isAuthenticated) return;

    let es = null;
    let reconnectTimer = null;

    const openConnection = () => {
      if (es) es.close();
      // Cookie is sent automatically for same-origin EventSource
      const url = `${API}/notifications/stream`;
      es = new EventSource(url, { withCredentials: true });

      es.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          onEventRef.current?.(data);
        } catch (err) {
          console.error('SSE parse error');
        }
      };

      es.onerror = () => {
        es.close();
        reconnectTimer = setTimeout(openConnection, 5000);
      };

      eventSourceRef.current = es;
    };

    openConnection();

    return () => {
      if (reconnectTimer) clearTimeout(reconnectTimer);
      if (es) es.close();
      eventSourceRef.current = null;
    };
  }, [isAuthenticated]);
}
